module.exports = __webpack_public_path__ + "static/media/hotel-quality-bed.321682c4.webp";